import { useLanguage } from '../contexts/LanguageContext';
import { Seo } from '../components/seo/Seo';
import { FaqSection } from '../components/seo/FaqSection';
import { FAQS } from '../components/seo/faqData';

export default function GroundingPage() {
    const { language } = useLanguage();
    return (
        <div className="max-w-3xl mx-auto p-6 pb-24" data-testid="grounding-page">
            <Seo
                title={language === 'de' ? 'Über BESTBUDDY – Funktionen & Betreiber' : 'About BESTBUDDY – Features & Operator'}
                description={language === 'de'
                    ? 'Alles über BESTBUDDY: KI-Wellness-App der MYSYMP AG mit Ernährungs-, Schlaf-, Fitness- und Gesundheits-Tracking, KI-Coach Nanouk und PDF-Arztberichten.'
                    : 'All about BESTBUDDY: AI wellness app by MYSYMP AG with nutrition, sleep, fitness and health tracking, AI coach Nanouk and PDF doctor reports.'}
                path={language === 'en' ? '/en/about' : '/about'}
                language={language}
                withHreflang
            />
            <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify({
                "@context": "https://schema.org",
                "@type": "SoftwareApplication",
                "name": "BESTBUDDY",
                "alternateName": ["Best Buddy", "BestBuddy App", "Nanouk Wellness App"],
                "url": "https://bestbuddy.fun",
                "description": "KI-Wellness-App mit Nanouk dem Husky. Schlaf, Ernährung, Fitness, Gesundheit tracken mit KI-Analyse und Gamification.",
                "applicationCategory": "HealthApplication",
                "operatingSystem": "Web (PWA)",
                "softwareVersion": "3.5.0",
                "inLanguage": ["de", "en"],
                "isAccessibleForFree": true,
                "offers": { "@type": "Offer", "price": "0", "priceCurrency": "CHF" },
                "author": {
                    "@type": "Organization", "name": "MYSYMP AG", "url": "https://mysymp.ch",
                    "address": { "@type": "PostalAddress", "streetAddress": "Studenstrasse 14B", "addressLocality": "Nottwil", "postalCode": "6207", "addressCountry": "CH" },
                    "founder": { "@type": "Person", "name": "Isidoro Celentano", "jobTitle": "CEO" }
                },
                "featureList": [
                    "KI-Ernährungsanalyse per Text und Foto (GPT-4o Vision)",
                    "Schlaf-Tracking mit Qualität und Verlauf",
                    "Fitness: Workouts, Golf (9/18 Loch), Wandern, Schritte",
                    "Gesundheit: Symptome + Behandlungen (TCM, Arzt, Physio)",
                    "Getränke: Wasser, Kaffee, Wein, Bier, Saft",
                    "KI-Coach Nanouk mit Foto-Upload und Sprachausgabe",
                    "Readiness Score, Gamification, Weekly Challenges",
                    "PDF-Berichte für Ärzte",
                    "Statistik Woche/Monat/YTD/Jahr"
                ]
            })}} />
            <article>
                <h1 className="text-3xl font-bold mb-2">BESTBUDDY</h1>
                <p className="text-lg text-muted-foreground mb-6">KI-Wellness-App mit Nanouk dem Husky</p>
                <section className="mb-6">
                    <h2 className="text-xl font-bold mb-3">Was ist BESTBUDDY?</h2>
                    <p className="text-sm text-muted-foreground">BESTBUDDY ist eine umfassende Wellness-App der MYSYMP AG (Nottwil, Schweiz). Das Maskottchen Nanouk begleitet Nutzer als KI-Coach. Die App kombiniert Gesundheits-Tracking mit Gamification.</p>
                </section>
                <section className="mb-6">
                    <h2 className="text-xl font-bold mb-3">Funktionen</h2>
                    <dl className="space-y-2 text-sm">
                        <div><dt className="font-semibold">Ernährung</dt><dd className="text-muted-foreground">KI-Analyse, Barcode-Scanner, 12 Getränke-Schnellwahl</dd></div>
                        <div><dt className="font-semibold">Schlaf</dt><dd className="text-muted-foreground">Tracking mit Qualität, Verlauf, Abweichungs-Analyse</dd></div>
                        <div><dt className="font-semibold">Fitness</dt><dd className="text-muted-foreground">10 Workout-Typen inkl. Golf (9/18 Loch), Wandern, Schritte</dd></div>
                        <div><dt className="font-semibold">Gesundheit</dt><dd className="text-muted-foreground">Symptome + Behandlungen (TCM, Arzt, Physio, Labor)</dd></div>
                        <div><dt className="font-semibold">KI-Coach</dt><dd className="text-muted-foreground">Chat mit Foto-Upload und Sprachausgabe (TTS)</dd></div>
                    </dl>
                </section>
                <section className="mb-6">
                    <h2 className="text-xl font-bold mb-3">Betreiber</h2>
                    <p className="text-sm text-muted-foreground">MYSYMP AG, Studenstrasse 14B, 6207 Nottwil, Schweiz | CHE-192.170.455 | mysymp.ch</p>
                </section>
                <section>
                    <FaqSection faqs={FAQS.about[language]} language={language} />
                </section>
                <footer className="text-xs text-muted-foreground border-t border-border pt-4 mt-8">
                    <p>BESTBUDDY v3.5.0 | bestbuddy.fun | MYSYMP AG, Nottwil | Stand: Februar 2026</p>
                </footer>
            </article>
        </div>
    );
}
